import React from 'react';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { AiReports } from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/AITools/Templates';
import {
  DashboardConfig,
  ModuleConfig,
} from '@lifeomic/phc-web-toolkit/src/components/LayoutConfiguration/types';
import MemberDetail from './index';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    height: '100%',
  },
}));

const zoriReportsModuleConfig: ModuleConfig<{ displayAsDuration: boolean }> = {
  version: 1,
  module: {
    key: 'member-zori-reports',
    moduleType: 'd7af2393-f012-40e9-bb34-2a09e86a89b0',
    title: 'Zori Reports',
    layout: {
      w: 12,
      h: 20,
      minW: 1,
      minH: 1,
      x: 0,
      y: 0,
      isResizable: true,
    },
  },
  component: { displayAsDuration: false },
};

const zoriReportsDashboardConfig: DashboardConfig = {
  version: 1,
  modules: [zoriReportsModuleConfig],
};

const zoriReportsInjectedPropsBase = {
  moduleKey: zoriReportsModuleConfig.module.key,
  isModuleVisible: true,
  dateTickFilter: { min: 0, max: 0 },
  dateTickBounds: { min: 0, max: 0 },
  dateFilter: { min: new Date(0), max: new Date() },
  isInEditMode: false,
  deviceId: 'member-detail',
  moduleConfig: zoriReportsModuleConfig,
  onModuleConfigChange: () => undefined,
  onDynamicDataResolved: () => ({}),
  selectedDashboardConfig: zoriReportsDashboardConfig,
} as const;

type ZoriReportsContentProps = {
  member: fhir.Patient | null;
  memberId: string;
  fallback: React.ReactNode;
};

export const ZoriReportsContent: React.FC<ZoriReportsContentProps> = ({
  member,
  memberId,
  fallback,
}) => {
  const classes = useStyles({});

  if (!member) {
    return <>{fallback}</>;
  }

  return (
    <div className={classes.container}>
      <AiReports
        {...zoriReportsInjectedPropsBase}
        patient={{
          ...member,
          id: member.id || memberId,
        }}
      />
    </div>
  );
};

const MemberAiTools: React.FC = () => {
  return <MemberDetail section="ai-tools" />;
};

MemberAiTools.displayName = 'MemberAiTools';
export default MemberAiTools;
